<!--
 * @Author: ghy
 * @Date: 2023-07-18 15:59:44
 * @LastEditors: ghy
 * @LastEditTime: 2023-08-10 16:00:37
 * @Description: 
-->
<template>
  <div class="login">
    <div class="login-content">
      <div class="login-head">
        <img src="@/assets/loginhead.png" alt="" />
      </div>
      <div class="login-form">
        <el-form :model="form" ref="ruleFormsss" :rules="rules">
          <el-form-item prop="name">
            <el-input
              prefix-icon="el-icon-user-solid"
              v-model="form.name"
              placeholder="请输入登录名称"
              class="logininput"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              prefix-icon="el-icon-unlock"
              type="password"
              v-model="form.password"
              placeholder="请输入密码"
              show-password
              @keyup.enter.native="toDashBoard(form.name, form.password)"
              class="logininput"
            ></el-input>
          </el-form-item>
          <el-form-item prop="cahe">
            <el-input
              prefix-icon="el-icon-mobile-phone"
              v-model="form.caheCode"
              placeholder="请输入验证码"
              class="logininput"
              style="width: 200px"
              @keyup.enter.native="toDashBoard(form.name, form.password)"
            ></el-input>
            <img
              :src="caheInfo.content"
              style="
                display: inline-block;
                width: 110px;
                height: 36px;
                cursor: pointer;
              "
              @click="getCode"
            />
          </el-form-item>
        </el-form>
        <el-button
          class="loginbutton"
          type="primary"
          @click="toDashBoard(form.name, form.password)"
          >立即登录</el-button
        >
        <el-checkbox class="checklogin" v-model="checked"
          >记住登录状态</el-checkbox
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: "",
        password: "",
        caheCode: "",
      },
      rules: {
        name: [
          { require: true, message: "必填项", trigger: "blur" },
          { min: 3, max: 20, message: "长度在3-20个字符之间", trigger: "blur" },
        ],
        password: [
          { require: true, message: "必填项", trigger: "blur" },
          { min: 3, max: 20, message: "长度在3-20个字符之间", trigger: "blur" },
        ],
        cahe: [{ require: true, message: "必填项", trigger: "blur" }],
      },
      ruleFormsss: null,
      caheInfo: {},
      checked: false,
    };
  },
  methods:{
    // 查询验证码接口
    getCode() {
      getCode().then((res) => {
        this.caheInfo = res.result;
      });
    },
    //登录调用接口
    toDashBoard(name, password) {
      
    },
  }
};
</script>

<style lang="less" scoped>
.login {
  width: 1400px;
  padding: 20px 129px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  .login-content {
    width: 469px;
    height: 483px;
    border: 1px solid #ccc;
    .login-head {
      width: 100%;
      height: 138px;
      opacity: 1;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .login-form {
      width: 100%;
      height: 345px;
      background: rgba(255, 255, 255, 0.25);
      padding: 55px 75px 0 75px;
      box-sizing: border-box;
    }
  }
}
.loginbutton {
  width: 215px;
  margin-left: 55px;
}
.checklogin {
  margin-top: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #aeaeae;
}
</style>


// WEBPACK FOOTER //
// src/views/login.vue